import React, { Component } from 'react'
import PropTypes from 'prop-types'
import MarkdownLabel from '../../../mini/MarkdownLabel'
import { OEComponents } from '@opportunityeducation/oe-web-common'

import {
  getCompletedReviewInfo,
  getReviewApprovalStatus,
  getIntlReviewType
} from '../../../../utils/review'
import { getUserDisplayName } from '../../../../utils/name'
import UserName from '../../../mini/UserName'

export default class PreviousReview extends Component {
  render() {
    const { review } = this.props
    const { reviewer, criteria } = review
    const intlReviewType = getIntlReviewType(criteria)

    return (
      <div className={this.getPreviousReviewClass()}>
        <div
          className={`review-header ${
            review && !review.completed ? getReviewApprovalStatus(review) : ''
          }`}
        >
          {intlReviewType}
        </div>
        <div className="approval-rejection-info">
          <strong>{getCompletedReviewInfo(review)}</strong>
          &nbsp;&nbsp;
          <OEComponents.DateFormatter
            date={review.completed_at}
            includeTime={false}
          />
          {' at '}
          <OEComponents.Time time={review.completed_at} />
        </div>
        <div className="completed-review-comment-wrapper">
          {review && review.comment && review.comment.length > 0 && (
            <div>
              <div className="completed-review-comment">
                <MarkdownLabel
                  additionalCssClasses="completed-review-comment"
                  value={review.comment}
                />
              </div>
              <div className="reviewer-info-container">
                <div className="user-photo-wrapper">
                  <img src={reviewer.photo_url} />
                </div>
                <UserName
                  activeCertifications={reviewer.active_certifications}
                  userId={`previous-review-${reviewer.id}`}
                  rebuild
                >
                  <div className="reviewer-name">
                    {getUserDisplayName(reviewer)}
                  </div>
                </UserName>
              </div>
            </div>
          )}
          {review && (!review.comment || review.comment.length === 0) && (
            <div className="no-review-comment">
              <div className="user-photo-wrapper">
                <img src={reviewer.photo_url} />
              </div>
              <UserName
                activeCertifications={reviewer.active_certifications}
                userId={`previous-review-${reviewer.id}`}
                rebuild
              >
                <div className="reviewer-name">
                  {getUserDisplayName(reviewer)}
                </div>
              </UserName>
            </div>
          )}
        </div>
      </div>
    )
  }

  getPreviousReviewClass() {
    var cssClass = 'completed-review previous-review'
    this.props.previousNoCurrent ? (cssClass += ' previous-no-current') : ''

    return cssClass
  }
}

PreviousReview.propTypes = {
  review: PropTypes.object.isRequired,
  previousNoCurrent: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/components/quest/review/qualityreview/PreviousReview.js